/* istanbul ignore file */

import { ProjectNote } from './project-notes';

export class ProjectNotesServiceModel {
    loading = false;
    projectNotes = new Array<ProjectNote>();
    currentProjectNote: ProjectNote | null = null;
}
